import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const HealthReminder = ({ show, dismiss }) => {
  const history = useHistory();

  return (
    <Modal show={show} onHide={() => dismiss()} centered>
      <Modal.Dialog className="max-w-md">
        <Modal.Header className="border-0 pb-0 text-center d-block">
          <Modal.Title className="d-flex flex-column align-items-center gap-2 fs-5">
            <span>Complete Your Health Profile</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center text-base text-muted">
          Take a moment to fill in your health details. This helps your doctor
          provide you with better, personalised care.
        </Modal.Body>
        <Modal.Footer className="border-0 d-flex flex-column gap-2">
          <Button
            variant="outline-secondary"
            className="w-100"
            onClick={() => dismiss()}
          >
            Later
          </Button>
          <Button
            variant="danger"
            style={{ backgroundColor: "var(--primarycolor)" }}
            className="w-100 text-white bg-rose-500"
            onClick={() => history.push("/health-info/start")}
          >
            Update Now
          </Button>
        </Modal.Footer>
      </Modal.Dialog>
    </Modal>
  );
};

export default HealthReminder;
